import styled from 'styled-components';

export const StoreCardContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  gap: 12px;
  margin: 16px 0;
  width: 100% !important;
  align-items: stretch !important;
  padding: 10px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;
  width: 100%;

  h4 {
    margin: 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    flex: 1;
  }
`;

export const StoreCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 2px solid var(--primary);
  border-radius: 8px;
  background-color: #f8f9ff;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
`;

export const CardContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
`;

export const RadioButton = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid var(--primary);
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--primary);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    transition: opacity 0.2s ease;
  }
`;

export const StoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StoreTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const StoreDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
`;

export const StorePrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 16px;
`;

export const PriceValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: var(--primary);
`;

export const StoreAddressInfo = styled.div`
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 6px;
  margin-top: 12px;
`;

export const AddressText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
`;
